// extracted by mini-css-extract-plugin
module.exports = {"numberItem":"requirementsimplified_numberItem__3j0a8","descriptionItem":"requirementsimplified_descriptionItem__1LDpl"};